// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
    position: absolute;
  }
  
  .loader:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    width: 5em;
    height: 0.5em;
    border-radius: 0.5em;
    transform: translate(-50%, -50%);
    animation: slide 2.5s infinite;
  }
  
  @keyframes slide {
    0% {
      width: 5em;
      box-shadow:
        1em -0.5em #2b546b,
        -1em 0.5em #aabbc4;
    }
  
    35% {
      width: 0.5em;
      box-shadow:
        0 -0.5em #2b546b,
        0 0.5em #aabbc4;
    }
  
    70% {
      width: 0.5em;
      box-shadow:
        -1em -0.5em #2b546b,
        1em 0.5em #aabbc4;
    }
  
    100% {
      width: 5em;
      box-shadow:
        1em -0.5em #2b546b,
        -1em 0.5em #aabbc4;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/Components/Loader/Loader.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,gCAAgC;IAChC,8BAA8B;EAChC;;EAEA;IACE;MACE,UAAU;MACV;;0BAEoB;IACtB;;IAEA;MACE,YAAY;MACZ;;uBAEiB;IACnB;;IAEA;MACE,YAAY;MACZ;;yBAEmB;IACrB;;IAEA;MACE,UAAU;MACV;;0BAEoB;IACtB;EACF","sourcesContent":[".loader {\n    position: absolute;\n  }\n  \n  .loader:before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    display: block;\n    width: 5em;\n    height: 0.5em;\n    border-radius: 0.5em;\n    transform: translate(-50%, -50%);\n    animation: slide 2.5s infinite;\n  }\n  \n  @keyframes slide {\n    0% {\n      width: 5em;\n      box-shadow:\n        1em -0.5em #2b546b,\n        -1em 0.5em #aabbc4;\n    }\n  \n    35% {\n      width: 0.5em;\n      box-shadow:\n        0 -0.5em #2b546b,\n        0 0.5em #aabbc4;\n    }\n  \n    70% {\n      width: 0.5em;\n      box-shadow:\n        -1em -0.5em #2b546b,\n        1em 0.5em #aabbc4;\n    }\n  \n    100% {\n      width: 5em;\n      box-shadow:\n        1em -0.5em #2b546b,\n        -1em 0.5em #aabbc4;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
